<template>
  <v-container fluid class="card-planta mt-14">
    <v-container
      fluid
      v-for="(itemPlanta, i) in plantWithDemands"
      :key="i + itemPlanta.cdPlantaAbate"
      class="ma-0 pa-0 card-item-planta mb-10 ml-0 d-flex flex-column flex-nowrap"
    >
      <v-row class="ma-0 flex-nowrap">
        <v-col class="pa-0 ma-0 colunm-1-dados-lote" cols="2">
          <v-item-group class="pa-2">
            <v-item>
              <v-layout row justify-center ma-0>
                <v-flex lg11>
                  <span class="text-planta-abate">Planta de Abate</span>
                  <br />
                  <span
                    :class="
                      demandAllFilled
                        ? 'text-planta-abate-sif-filled'
                        : 'text-planta-abate-sif-not-filled'
                    "
                  >SIF {{ itemPlanta.plantaAbate.nrRegistroSif }}</span
                  >
                  <br />
                  <span class="text-planta-abate-municipio">
                    {{ itemPlanta.plantaAbate.nmMunicipio }}
                  </span>
                  <br />
                  <div
                    class="container-fluid"
                  >
                    <lot-list-dialog
                      :cd-programacao-abate="
                        programacaoAbateSelected.idProgramacaoAbate
                      "
                      :cd-planta-abate="itemPlanta.cdPlantaAbate"
                      :nr-registro-sif="itemPlanta.plantaAbate.nrRegistroSif"
                    >
                      <template v-slot:activator="{ on }">
<!--                        :disabled="programacaoAbateSelected.cdStatusProgramacaoAbate === 5"-->
                        <v-btn
                          v-on="on"
                          class="btn-adicionar-lotes mt-2"
                        >
                          Inserir Lotes
                        </v-btn>
                      </template>
                    </lot-list-dialog>
                  </div>
                </v-flex>
              </v-layout>
            </v-item>
          </v-item-group>
        </v-col>
        <v-col
          v-for="(itemData, i) in listDatesWithDemand"
          :key="i + itemData.value"
          cols="2"
          class="pa-0 ma-0 colunm-2-dados-lote"
        >
          <v-hover v-slot:default="{ hover }">
            <v-row class="ma-0 fill-height p-relative">
              <CardLoteAlocadoColumn
                :itemData="itemData"
                :itemPlanta="itemPlanta"
                @animaisChanged="animaisChanged"
              />
              <v-overlay
                absolute
                :value="hover && isAbleToPaste"
              >
                <v-row
                  class="ma-0 pa-2 d-flex flex-column"
                  justify="center"
                  align="center"
                >
                  <v-sheet
                    class="borda-arredondada pa-2"
                  >
                    <v-row
                      align="center"
                      justify="center"
                      class="ma-0 d-flex flex-column"
                    >
                      <span class="subtitle-1 text-uppercase weight-projection-text">Peso estimado:</span>
                      <span class="subtitle-1 font-weight-bold pa-1">{{`${nrPesoDiaToCopy(itemData["text"])} Kg`}}</span>
                    </v-row>
                  </v-sheet>
                  <v-btn
                    block
                    @click="ActionPasteProgAbateAlocado({
                      stDiaAlocado: itemData['value'],
                      dtAlocado: itemData['text'],
                      cdPlantaAbate: itemPlanta.cdPlantaAbate,
                      nrPesoDia: nrPesoDiaToCopy(itemData['text'])
                    })"
                    class="my-1"
                  >
<!--                    <v-icon left>fas fa-paste</v-icon>-->
                    Colar
                  </v-btn>
                  <v-btn
                    block
                    @click="cancelPaste"
                    class="my-1"
                  >
                    Cancelar
                  </v-btn>
                </v-row>
              </v-overlay>
            </v-row>
          </v-hover>
        </v-col>
      </v-row>
      <!--      <v-row class="ma-0 flex-nowrap stick-total-plant-demand" style="height: 70px;">-->
      <!--        <v-col-->
      <!--          class="ma-0 pa-0 card-lotes-confirmados colunm-1-dados-demanda"-->
      <!--          cols="2"-->
      <!--        >-->
      <!--          <v-item-group class="pl-3 pt-3">-->
      <!--            <v-item>-->
      <!--              <span class="text-demanda-plantas">Demanda da planta</span>-->
      <!--            </v-item>-->
      <!--          </v-item-group>-->
      <!--        </v-col>-->
      <!--        <v-col-->
      <!--          v-for="(itemData, i) in listDatesWithDemand"-->
      <!--          :key="i + itemData.value + 1"-->
      <!--          cols="2"-->
      <!--          class="ma-0 pa-0 card-lotes-confirmados colunm-2-dados-demanda"-->
      <!--        >-->
      <!--          <v-item-group class="pt-3">-->
      <!--            <v-item>-->
      <!--              <v-layout row justify-center>-->
      <!--                <v-flex lg12>-->
      <!--                  <CardItemTotalDemand-->
      <!--                    :itemData="itemData"-->
      <!--                    :itemPlanta="itemPlanta"-->
      <!--                    :listaLotes="listBatchsAllocated"-->
      <!--                    :qtTotalDemand="itemPlanta[itemData.value]"-->
      <!--                  />-->
      <!--                </v-flex>-->
      <!--              </v-layout>-->
      <!--            </v-item>-->
      <!--          </v-item-group>-->
      <!--        </v-col>-->
      <!--      </v-row>-->
    </v-container>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex"
import moment from "moment"

import LotListDialog from "@/modules/programacaoAbate/components/LotTab/LotListDialog"
import CardLoteAlocadoColumn from "@/modules/programacaoAbate/components/CardLoteAlocadoColumn"
import CardItemTotalDemand from "@/modules/programacaoAbate/components/CardItemTotalDemand"

export default {
  name: "ItemPlantaAbateProgramacaoLotes",
  components: {
    LotListDialog,
    CardLoteAlocadoColumn,
    CardItemTotalDemand
  },
  computed: {
    ...mapState("programacaoAbate", [
      "listBatchsAllocated",
      "programacaoAbateSelected",
      "listDatesWithDemand",
      "listaDemandasPlanta",
      "isCutting",
      "isCopying",
      "idProgramacaoAbateAlocadoToCopy"
    ]),
    plantWithDemands() {
      return this.listaDemandasPlanta.filter(item => item.qtTotalDemanda)
        .sort((a, b) => a.plantaAbate.idPlantaAbate - b.plantaAbate.idPlantaAbate);
    },
    isAbleToPaste() {
      return this.isCutting || this.isCopying
    },
  },
  data() {
    return {
      demandAllFilled: false
    }
  },
  props: {},
  methods: {
    animaisChanged() {
      this.$emit("animaisChanged")
    },
    nrPesoDiaToCopy(dtProjecao) {
      if (!this.idProgramacaoAbateAlocadoToCopy) return ""
      const foundLot = this.listBatchsAllocated.find(item => (
        item["idProgramacaoAbateAlocado"] === this.idProgramacaoAbateAlocadoToCopy
      ))
      if (!foundLot) return ""
      
      const projecao = foundLot["listaProjecaoPeso"].find(item => (
        item["dtProjecao"] === moment(dtProjecao, "DD/MM/YYYY").format("YYYY-MM-DD")
      ))
      if (!projecao) return ""
      
      return projecao.nrPeso
    },
    cancelPaste() {
      this.ActionCancelPasteProgAbateAlocado()
    },
    ...mapActions("programacaoAbate", ["ActionPasteProgAbateAlocado", "ActionCancelPasteProgAbateAlocado"])
  }
}
</script>

<style scoped lang="scss">
.weight-projection-text {
  font-size: 0.875rem !important;
  font-weight: 500 !important;
      letter-spacing: 0.0892857143em !important;

}

</style>
